import qs from 'qs';

import { shopsApi } from './shops.api';

const actionPrefix = (actionType) => `Shops/${actionType}`;

export const SET_SHOPS = actionPrefix`SET_SHOPS`;
export const setShops = (shops) => ({
  type: SET_SHOPS,
  payload: shops,
});

export const loadShops = (query, currentLocation, top) => (dispatch, getState) => {
  const {
    appointment: {
      draft: {
        appointmentType: { id: appointmentTypeId },
      },
    },
    services: {
      config: { ignoreAppointmentType },
    },
  } = getState();

  let queryParameters = {
    appointmentTypeId: !ignoreAppointmentType ? appointmentTypeId : undefined,
    q: query,
    top,
  };
  if (currentLocation) {
    queryParameters = { ...queryParameters, currentLocation };
  }

  return shopsApi
    .fetch(`?${qs.stringify(queryParameters, { skipNulls: true })}`)
    .then((response) => {
      const { stores: shops } = response;
      dispatch(setShops(shops));

      return {
        ...response,
        shops,
      };
    });
};

export const shopsActions = {
  setShops,
  loadShops,
};
